<div
    appTbDropContainer
    orientation="vertical"
    class="w-[20.75rem] h-full flex flex-col"
    [class.collapsed]="collapsed()"
    [indicatorVisible]="false"
    [dropDisabled]="disableDragIntoList()"
    [data]="{ items }"
    [captureChildDropEvents]="false"
    (enteredContainer)="onDrag($event)"
    (exitedContainer)="onDragLeave()"
    (droppedContainer)="onDrop($event)"
>
    <div class="px-2">
        <ng-container *ngTemplateOutlet="header"></ng-container>
    </div>
    <div
        cdkVirtualScrollingElement
        appTbDragAutoScroll
        class="h-full"
        style="scrollbar-gutter: stable"
    >
        <cdk-virtual-scroll-viewport
            class="h-full"
            orientation="vertical"
            dynamicSize
            minBufferPx="400"
            maxBufferPx="400"
            [sizes]="columnWidths()"
            [stretch]="true"
            [disableAppending]="true"
            [class.hidden]="collapsed()"
        >
            <div class="h-full w-full">
                <div *cdkVirtualFor="let item of items; let index = index; trackBy: trackBy">
                    <ng-container
                        *ngTemplateOutlet="
                            card();
                            injector: cardInjector();
                            context: { item, group: columnItem(), index: index }
                        "
                    ></ng-container>
                </div>

                @if (showPlaceholder()) {
                    <div
                        class="border-2 w-full border-dashed border-primary opacity-75 rounded"
                    ></div>
                }
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
</div>

<ng-template #header>
    <app-tb-board-column-header
        [items]="items"
        [moreMenu]="headerMenu()"
        [columnItem]="columnItem()"
        [selectedItems]="selectedItems()"
        [collapsed]="collapsed()"
        [controlCollapse]="isCollapsedSet()"
        (collapseChanges)="toggleCollapse($event)"
        (selectColumn)="selectColumn.emit($event)"
    >
        <ng-content select="[header]"></ng-content>
    </app-tb-board-column-header>
</ng-template>
